import { cognitoAuth } from './CognitoUtil';

export const authUtil = cognitoAuth;
